import {
  CheckCircleOutlineOutlined,
  ErrorOutline,
  InfoOutlined,
  WarningAmberOutlined,
} from "@mui/icons-material";

import {
  Paper,
  Modal,
  Typography,
  Button,
  Box,
  alpha,
  useTheme,
} from "@mui/material";
import React from "react";

type Severity = "success" | "error" | "warning" | "info";

interface AlertModalProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  confirmar?: boolean;
  handleButton: () => void;
  handleCancel?: () => void;
  severity: Severity;
  textContent?: string;
  singleButton?: boolean;
  customButton?: boolean;
  buttonText?: string;
  buttonCancelText?: string;
}

const NewAlertModal: React.FC<AlertModalProps> = (props) => {
  const {
    openModal,
    setOpenModal,
    confirmar = false,
    handleButton = () => {},
    handleCancel = () => {},
    severity = "success",
    textContent,
    singleButton = true,
    customButton,
    buttonText,
    buttonCancelText,
  } = props;
  const theme = useTheme();
  const alertText = () => {
    if (textContent) {
      return textContent;
    }
    return severity === "success"
      ? "Sucesso na operação!"
      : severity === "warning"
      ? "Se você prosseguir com a operação o item será editado permanentemente e os dados anteriores são perdidos!"
      : severity === "info"
      ? "Está ação pode ser permanentemente!"
      : "Se você prosseguir com a operação o item será deletado e os dados apagados serão perdidos permanentemente!";
  };
  const alertTitle = () => {
    return severity === "success"
      ? "Sucesso!"
      : severity === "warning"
      ? "Alerta!"
      : severity === "info"
      ? "Informação"
      : "Atenção!";
  };
  const buttonTextDefault = () => {
    if (buttonText) {
      return buttonText;
    }
    return severity === "success"
      ? "Aceitar"
      : severity === "warning"
      ? "Prosseguir"
      : severity === "info"
      ? "Confirmar"
      : "Excluir";
  };

  const color = () => {
    return severity === "success"
      ? "success.main"
      : severity === "warning"
      ? "warning.main"
      : severity === "info"
      ? "info.main"
      : "error.main";
  };
  const stylesModal = {
    modal: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      alignItems: "center",
    },
    paperHeader: {
      padding: 2.5,
      maxWidth: "432px",
      width: "100%",
      minWidth: "232px",
      maxHeight: "90vh",
      gap: 2,
      flexDirection: "column",
      display: "flex",
      alignItems: "felx-start",
      backgroundColor: "background.default",
      borderRadius: 1,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    paperBody: {
      padding: 2.5,
      maxWidth: "432px",
      width: "100%",
      minWidth: "232px",
      maxHeight: "90vh",
      gap: 2,
      flexDirection: "column",
      display: "flex",
      alignItems: "felx-start",
      backgroundColor: "background.textField",
      borderRadius: 1,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
    },
    boxHeader: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "start",
      gap: 2,
      width: "100%",
    },
    boxBody: {
      display: "flex",
      flexDirection: "row",
      gap: 2,
      justifyContent: "flex-end",
      alignItems: "center",
    },
    boxRowFields: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      with: "100%",
      gap: 2,
    },
    buttonConfirm: {
      fontWeight: 500,
      backgroundColor: `${color()}`,
      color: "#FFFFFF",
      borderRadius: "3px",
    },
    buttonCancel: {
      backgroundColor: "text.disabled",
      color: "#FFFFFF",
      borderRadius: "3px",
    },
    icon: {
      width: "30px",
      height: "30px",
      backgroundColor:
        severity === "error"
          ? alpha(theme.palette.error.main, 0.4)
          : severity === "success"
          ? alpha(theme.palette.success.main, 0.4)
          : severity === "warning"
          ? alpha(theme.palette.warning.main, 0.4)
          : alpha(theme.palette.info.main, 0.4),
      color:
        severity === "error"
          ? "error.main"
          : severity === "success"
          ? "success.main"
          : severity === "warning"
          ? "warning.main"
          : "info.main",
      padding: 0.3,
      borderRadius: 0.5,
    },
  };

  return (
    <Modal
      open={openModal}
      closeAfterTransition
      onClose={() => {
        setOpenModal(false);
      }}
      sx={stylesModal.modal}
    >
      <>
        {" "}
        <Paper sx={stylesModal.paperHeader}>
          <Box sx={stylesModal.boxHeader}>
            <Box sx={stylesModal.boxRowFields}>
              {severity === "success" ? (
                <CheckCircleOutlineOutlined sx={stylesModal.icon} />
              ) : severity === "error" ? (
                <ErrorOutline sx={stylesModal.icon} />
              ) : severity === "info" ? (
                <InfoOutlined sx={stylesModal.icon} />
              ) : (
                <WarningAmberOutlined sx={stylesModal.icon} />
              )}

              <Typography variant="h5">{alertTitle()}</Typography>
            </Box>
            <Typography variant="h3" fontSize={16} color="text.secondary">
              {alertText()}
            </Typography>
          </Box>
        </Paper>
        <Paper sx={stylesModal.paperBody}>
          <Box sx={stylesModal.boxBody}>
            {singleButton === true ? (
              <Button
                autoFocus
                variant="contained"
                color={severity}
                sx={stylesModal.buttonConfirm}
                onClick={handleButton}
                disabled={confirmar}
              >
                {buttonTextDefault()}
              </Button>
            ) : (
              <>
                <Button
                  variant="contained"
                  color="inherit"
                  onClick={() => {
                    setOpenModal(false);
                    handleCancel();
                  }}
                  sx={stylesModal.buttonCancel}
                >
                  {buttonCancelText ?? "Cancelar"}
                </Button>

                <Button
                  autoFocus
                  variant="contained"
                  color={severity}
                  sx={stylesModal.buttonConfirm}
                  onClick={handleButton}
                  disabled={confirmar}
                >
                  {buttonTextDefault()}
                </Button>
              </>
            )}
            {customButton}
          </Box>
        </Paper>
      </>
    </Modal>
  );
};

export default NewAlertModal;
